module.exports = __webpack_public_path__ + "img/Logo2Tor_Gris.5aa46e29.png";